/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 17/1/2022
 */
import BaseObject from "@shared/BaseObject.js";
import {uuidv4} from "@/utils/helpers";
import {TimeLineItemColors} from "@shared/Timeline/TimeLineItemColors";

export default class TimelineEventItem extends BaseObject {

	id: string = null
	title: string = null
	description: string = null
	eventAge: number = 0
	eventAgeEnd: number = 0
	eventScore: number = 0


	constructor() {
		super();
		this.id = uuidv4()
	}


	getColor(){
		let sortedKeys = Object.keys(TimeLineItemColors).sort((l, r) => Number(l) - Number(r))
		let index = 0
		while(index < sortedKeys.length - 1 && sortedKeys[index] <= this.eventScore + Math.ceil(sortedKeys.length / 2)){
			index++
		}
		return TimeLineItemColors[sortedKeys[index]]
	}
}
